<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {},
  mounted() {
    // 根据不同路由跳转不同页面
    if (this._isMobile()) {
      console.log("手机端");
      this.$router.replace({
        name: "MobileHome"
      });
    } else {
      console.log("pc端");
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style scoped lang="scss">
#app {
  -webkit-text-size-adjust: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue